import React from 'react';
import mapCurrency from 'currency-symbol-map';

import { RenderAsHTMLStyles } from '@src/features/common';
import { Flex, Text, TextBox, BaseBox } from 'src/kit';
import { StyledJobCard as StyledCard } from '../atoms/StyledJobCard';
import { ILearningCard } from '../models/LearningModel';

function LearningCard({ data, onClick }: { data: ILearningCard; onClick: () => void }) {
  const currencySymbol = mapCurrency(data.currency);
  const GBPIcon = mapCurrency('GBP');

  return (
    <StyledCard onClick={onClick}>
      <div className="cover-wrapper">
        <img src={data.cover_image_url} className="cover" alt={'Card Cover'} />
        <img className="logo" src={data.provider_logo_url} alt={data.title} />
      </div>
      <Flex height="calc(100% - 110px)" flexDirection="column" p={20} pb={30} flex={1}>
        <Text mb={10} fontSize="16px" textStyle="ellipsis" title={data.title} fontWeight="bold" color="textPrimary">
          {data.title}
        </Text>
        <Text mb={42} textStyle="ellipsis" fontSize="14px" color="blueGreyTwo" style={{ maxHeight: '40px', overflow: 'hidden' }}>
          <RenderAsHTMLStyles dangerouslySetInnerHTML={{ __html: data.short_desc_html }} />
        </Text>
        <Flex flex="1" alignItems="flex-end" color="textPrimary">
          {Number(data.price) === 0 ? (
            <TextBox fontSize="16px" height="16px" fontWeight="bold">
              Free
            </TextBox>
          ) : (
            <>
              {data.price && (
                <>
                  {data.currency !== 'GBP' && (
                    <>
                      <TextBox fontSize="16px" height="16px" fontWeight="bold">
                        {`${GBPIcon} ${Number(data.gbp_price).toLocaleString()}`}
                      </TextBox>
                      <BaseBox ml={'3px'} />
                      {` / `}
                      <BaseBox ml={'2px'} />
                    </>
                  )}
                </>
              )}
              {/* Original price */}
              {/*  currency icon execpt chinese Yuan currency  */}
              {data.price && data.currency !== 'CNY' && currencySymbol && (
                <TextBox fontSize="14px" height="14px" color="textSecondary" fontWeight="bold">
                  {` ${currencySymbol}`}
                </TextBox>
              )}
              {/* PRICE */}
              <TextBox fontSize="14px" height="14px" color="textSecondary" fontWeight="bold">
                {data.price ? Number(data.price).toLocaleString() : 'Free'}
              </TextBox>
              {/* chinese Yuan currency */}
              {data.currency === 'CNY' && (
                <TextBox fontSize="14px" height="14px" color="textSecondary" fontWeight="bold">
                  {`${currencySymbol}`}
                </TextBox>
              )}
            </>
          )}
        </Flex>
      </Flex>
    </StyledCard>
  );
}

export default LearningCard;
